import { h } from "vue";
import { prefix } from "../prefix";
import { ToolOutlined } from "@ant-design/icons-vue";
import { getComponent } from "../utils";
import Layout from '@/layouts/main-layout.vue'
import type { RouteRecordRaw } from "vue-router";

export const tool_routes: RouteRecordRaw[] = [
  {
    path: '/tool/list',
    name: 'tool-list',
    component: () => getComponent(`pages/tool/tool-list.vue`),
    meta: {
      title: () => 'Tools',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Tools',
        label: 'Tools',
        icon: () => h(ToolOutlined),
        path: `${prefix}/tool/list`,
      },
    },
  },
  {
    path: '/tool/:id(\\d+)+',
    name: 'tool-details',
    component: () => getComponent(`pages/tool/tool-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Tool #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/tool/new',
    name: 'tool-new',
    component: () => getComponent(`pages/tool/tool-new.vue`),
    meta: {
      title: () => `New Tool`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/tool/:id(\\d+)+/edit',
    name: 'tool-edit',
    component: () => getComponent(`pages/tool/tool-edit.vue`),
    meta: {
      title: () => `Edit Tool`,
      layout: Layout,
      is_public: false,
    },
  },
]
